export interface IPaymentReceiptDetails {
  orderId: string;
  unifiedReferenceNumber: string;
  dateOrdered: string;
  status: string;
  payment: IReceiptPayment;
  subTotal: number;
  memberDiscount: number;
  shippingTotal: number;
  taxTotal: number;
  total: number;
  billingAddress: IAddress;
  shipFromAddress: IAddress;
  receiptItems: Array<IReceiptItems>;
  dateRefunded: string;
  isOrderReturned: boolean;
  isNoCostOrder: boolean;
  isVerifoneOrder: boolean;
  lob: string;
  companyName: string | null;
  firstName: string | null;
  lastname: string | null;
}

export interface IAddress {
  userId: number;
  addressId: string;
  firstName: string;
  lastName: string;
  street1: string;
  street2: string;
  city: string;
  state: string;
  zip: string;
  country: string;
  phone: string;
  isShipping: boolean;
  isBilling: boolean;
  isPrimary: boolean;
}

export interface IReceiptItems {
  lineItemId: string;
  productTitle: string;
  productCode: string;
  format: string;
  unitPrice: number;
  language: string;
  modality: string | null;
  sessionStartDate: string | null;
  sessionEndDate: string | null;
  sessionDescription: string | null;
  examWindow: string;
  quantity: number;
  lineTotal: number;
  quantityShipped: number;
  itemShipped: boolean;
  isShipmentItem: boolean;
  isDigitalItem: boolean;
  digitalCopySent: boolean;
  digitalCopiesSendAddresses: Array<string>;
  shipToAddress: IAddress;
  icpContactId: string;
  surchargeCost: number;
  surchargeType: string;
}

export interface IReceiptPayment {
  paymentType: string;
  paymentMethod: string;
  verifonePaymentType: string;
  paymentProcessed: boolean;
  last4DigitsCCNumber: string;
  cardType: string;
}

export default {};
